import _defineProperty from "@babel/runtime/helpers/defineProperty";
export default class InterceptorManager {
  constructor() {
    _defineProperty(this, "handlers", []);
  }
  use(onFulfilled, onRejected) {
    this.handlers.push({
      fulfilled: onFulfilled,
      rejected: onRejected
    });
    return this.handlers.length - 1;
  }
  eject(id) {
    // istanbul ignore else
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  forEach(fn) {
    this.handlers.forEach(handler => {
      // istanbul ignore else
      if (handler !== null) {
        fn(handler);
      }
    });
  }
}
//# sourceMappingURL=InterceptorManager.js.map